import { useListProjectVariablesQuery } from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import { ProjectVariable } from "../types/Location";

const useListServiceLocationVariables = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data, isLoading } = useListProjectVariablesQuery({
    slug: accountSlug,
    filter: { "variable-context": "service_location" },
  });

  const variables: ProjectVariable[] =
    data?.data?.map((pv: any) => {
      const attr = pv.attributes;
      return {
        name: attr?.name || "",
        label: attr?.label || "",
        variable_type: attr?.["variable-type"],
        minimum: attr?.minimum,
        maximum: attr?.maximum,
        required: attr?.required ?? false,
        select_options: attr?.["select-options"] || [],
        position: attr?.position,
        context: attr?.context,
        uuid: attr?.uuid,
        value: "",
      };
    }) || [];

  return { variables, variablesLoading: isLoading };
};

export default useListServiceLocationVariables;
